import React from 'react';
import { v4 as uuid } from 'uuid';
import PropTypes from 'prop-types';

import StructureModel from '@Components/Results/structure/structure-model.service';
import { withStructureContext } from '@Components/Results/structure/StructureContext';
import HoverTooltip from '@Components/HoverTooltip';

import { openWith3d as openWith3dStructureDialog } from '@Containers/StructureDialog/StructureDialogAction';
import store from '@Store';
import { ButtonWithIcon } from '@els/els-react--button';

import './StructureToolbarOptions.scss';

function StructureToolbarZoom({ tooltipId, onOpen = () => {}, structure }) {
  const zoomInStructure = () => {
    const chemicalName = structure?.details?.chemicalNames?.[0] || '';
    store.dispatch(openWith3dStructureDialog(uuid(), structure?.molImage?.structure, chemicalName));
  };

  const tooltipLabel = 'Zoom in on structure';

  return (
    <div style={{ position: 'relative' }}>
      <HoverTooltip id={tooltipId} tooltip={tooltipLabel} tooltipPlace="top" theme="simple">
        <span id="zoomin-button-description" className="sr-only">
          The Structure will appear four times larger in the model with option to view in 3D
        </span>
        <ButtonWithIcon
          data-e2e="structure-toolbar-zoomin-button"
          sprite="ZoomIn"
          type="borderless"
          iconOnly
          onClick={() => {
            zoomInStructure();
            onOpen();
          }}
          aria-describedby="zoomin-button-description"
          aria-haspopup="dialog">
          Zoom in on structure
        </ButtonWithIcon>
      </HoverTooltip>
    </div>
  );
}

StructureToolbarZoom.propTypes = {
  structure: PropTypes.instanceOf(StructureModel),
  onOpen: PropTypes.func,
  tooltipId: PropTypes.string,
};

const StructureToolbarZoomWithContext = withStructureContext(StructureToolbarZoom);
export default StructureToolbarZoomWithContext;
